import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api';

import { clientPracticeMessageDestroyApi } from './destroy';

export function clientPracticeMessageApi(path: string) {
  return {
    path,
    GET: () =>
      api.get<JsonApiResponseSingle>(path, {
        params: {
          include: 'creator',
        },
      }),
    destroy: () => clientPracticeMessageDestroyApi(path),
  };
}
